// extracted by mini-css-extract-plugin
module.exports = {"TotalPrice":"TotalPrice_TotalPrice__3cSqe","Price":"TotalPrice_Price__2P1yY","PriceContainer":"TotalPrice_PriceContainer__17vmr","Iva":"TotalPrice_Iva__3lxTr"};